import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const DiseñoSolucionPropuestaTecnicoComercialRACI = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/04-diseño-de-solucion-y-propuesta-tecnico-comercial-RACI.pdf`;
  /*const pdfUrl = "/pdf/04-diseño-de-solucion-y-propuesta-tecnico-comercial-RACI.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Diseño de Solución y Propuesta Técnico-Comercial Matriz RACI</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Diseño de Solución y Propuesta Técnico-Comercial Matriz RACI" />
      </Container>
    </>
  );
};

 export default DiseñoSolucionPropuestaTecnicoComercialRACI;
